import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services';

@Component({
  selector: 'app-oidc-login',
  templateUrl: './oidc-login.component.html',
  styleUrls: ['./oidc-login.component.scss'],
})
export class OidcLoginComponent implements OnInit {
  public disabled = false;
  public error_msg: string;

  constructor(private auth: AuthService) { }

  ngOnInit(): void { }

  public onSubmit($event: Event): void {
    this.disabled = true;
    $event.preventDefault();
    this.auth.oidcLogin();
  }
}
